import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import AuthShell, { AuthNotice } from '../Auth/AuthShell';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const apiUrl = import.meta.env.VITE_API_URL;
    const resetUrl = `${apiUrl}/api/password_reset/`;
    
    console.log('🔍 Password reset request initiated');
    console.log('📧 Email:', email);
    console.log('🌐 API URL:', resetUrl);
    console.log('⚙️ Environment:', import.meta.env.MODE);

    try {
      console.log('📤 Sending password reset request...');
      const response = await axios.post(
        resetUrl,
        { email },
        { withCredentials: true }
      );
      console.log('✅ Password reset response received:', response);
      console.log('📊 Response status:', response.status);
      console.log('📄 Response data:', response.data);
      setMessage(response.data.detail || 'A reset link has been sent to your email.');
    } catch (error) {
      console.error('❌ Password reset error:', error);
      console.error('🔍 Error details:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        config: {
          url: error.config?.url,
          method: error.config?.method,
          headers: error.config?.headers,
          withCredentials: error.config?.withCredentials
        }
      });
      setMessage('Failed to send the reset link. Please try again.');
    }
  };

  return (
    <AuthShell
      title="Reset Password"
      subtitle="Enter the email address you sign in with and we'll send you a link to choose a new password."
      footer={
        <>
          Remembered your password?{' '}
          <Link to="/login" className="link">
            Sign in
          </Link>
        </>
      }
    >
      <form className="space-y-5" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email-address" className="label">
            Email address
          </label>
          <div className="relative">
            <input
              id="email-address"
              name="email"
              type="email"
              autoComplete="email"
              required
              className="input h-11 pr-10"
              placeholder="you@example.com"
              value={email}
              onChange={handleEmailChange}
            />
            <Mail className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          </div>
        </div>

        {message && (
          <AuthNotice tone={message.startsWith('Failed') ? 'danger' : 'info'}>{message}</AuthNotice>
        )}

        <button type="submit" className="btn btn-primary btn-lg w-full">
          Send Reset Link
        </button>
      </form>
    </AuthShell>
  );
};

export default ForgotPassword;
